interface GetGapChannelDetectionsCellValueInput {
    gapChannel: TrqkGapChannel;
    gapDenominator: number;
}

export const getGapChannelDetectionsCellValue = ({
    gapChannel,
    gapDenominator,
}: GetGapChannelDetectionsCellValueInput): GapChannelDetectionsCellValue => {
    const { detections_raw } = gapChannel;

    return {
        detectionsCount: detections_raw,
        gapDenominator,
    };
};
